import { createAction, createAsyncAction } from 'typesafe-actions';
import { HttpErrorData } from '../../../../types';

export const getFeed = createAction('FEED_GET', (action) => (nextPageId?: string) => action(nextPageId));
export const getFeedRequest = createAsyncAction('FEED_REQUEST', 'FEED_SUCCESS', 'FEED_REJECTED')<
  undefined,
  any,
  HttpErrorData
>();
